import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import "../css/application.css";

// Exclude co-located *.test.tsx files so test code never ships in the bundle.
const pages = import.meta.glob(["../pages/**/*.tsx", "!../pages/**/*.test.tsx"]);

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      throw new Error(`Page not found: ${name}`);
    }
    return page();
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});
